import React from 'react';
import '../../index.scss';
import {
    SCALE_MIN,
    SCALE_MAX,
    BAND_MIN,
    BAND_MAX,
    chipForGap,
    scalePct,
} from '../../constants';

// Whole-number ticks across the scale (1..6).
const TICKS = Array.from(
    { length: SCALE_MAX - SCALE_MIN + 1 },
    (_, i) => SCALE_MIN + i
);

const bandLeft = scalePct(BAND_MIN);
const bandWidth = scalePct(BAND_MAX) - scalePct(BAND_MIN);

const formatDelta = (gap) => {
    const sign = gap > 0 ? '+' : gap < 0 ? '−' : '';
    return `${sign}${Math.abs(gap).toFixed(2)}`;
};

const DumbellChart = (props) => {
    return (
        <>
            {/* Header: category label, the numbered axis, and the delta title */}
            <div className='divergence__header'>
                <span className='divergence__head-category'>Category</span>
                <div className='divergence__axis'>
                    <span
                        className='divergence__band'
                        style={{ left: `${bandLeft}%`, width: `${bandWidth}%` }}
                    />
                    {TICKS.map((tick) => (
                        <span
                            key={tick}
                            className='divergence__tick'
                            style={{ left: `${scalePct(tick)}%` }}
                        >
                            {tick}
                        </span>
                    ))}
                </div>
                <span className='divergence__head-delta'>&Delta; Self &minus; Others</span>
            </div>

            {/* One row per category */}
            <div className='divergence__rows'>
                {props.divergenceData.map((row) => {
                    const gap = row.gap
                    const chip = chipForGap(row.severity);
                    const selfPct = scalePct(row.self);
                    const othersPct = scalePct(row.others);
                    const connectorLeft = Math.min(selfPct, othersPct);
                    const connectorWidth = Math.abs(selfPct - othersPct);

                    return (
                        <div className='divergence__row' key={row.category}>
                            <div className='divergence__category'>
                                <span className='divergence__category-name'>{row.category}</span>
                                <span className='divergence__category-meta'>
                                    Self {row.self.toFixed(2)} &middot; Others {row.others.toFixed(2)}
                                </span>
                            </div>

                            <div className='divergence__plot'>
                                <span
                                    className='divergence__band'
                                    style={{ left: `${bandLeft}%`, width: `${bandWidth}%` }}
                                />
                                <span
                                    className='divergence__connector'
                                    style={{ left: `${connectorLeft}%`, width: `${connectorWidth}%` }}
                                />
                                <span
                                    className='divergence__marker divergence__marker--others'
                                    style={{ left: `${othersPct}%` }}
                                    title={`Others ${row.others.toFixed(2)}`}
                                />
                                <span
                                    className='divergence__marker divergence__marker--self'
                                    style={{ left: `${selfPct}%` }}
                                    title={`Self ${row.self.toFixed(2)}`}
                                />
                            </div>

                            <span className={`divergence__chip divergence__chip--${chip.modifier}`}>
                                {chip.label}
                            </span>

                            <span className='divergence__delta'>{formatDelta(gap)}</span>
                        </div>
                    );
                })}
            </div>

            {/* Footer: legend + the coaching-threshold note */}
            <div className='divergence__footer'>
                <div className='divergence__legend'>
                    <span className='divergence__legend-item'>
                        <span className='divergence__dot divergence__dot--self' />
                        Self
                    </span>
                    <span className='divergence__legend-item'>
                        <span className='divergence__dot divergence__dot--others' />
                        All But Self
                    </span>
                </div>
                <span className='divergence__note'>
                    Gaps of 0.30 or more typically warrant a coaching conversation.
                </span>
            </div>
        </>
    );
};

export default DumbellChart;
